module.exports = __webpack_public_path__ + "img/join-out-community.6f1c7340.png";